module.exports = __webpack_public_path__ + "img/package-4.7648381c.png";